
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getRolePersonnelInfo, createRole, editRole } from '@/api/users';
import { UserModule } from '../../../store/modules/user';
import { treeNode } from 'element-ui/types/table';
import ElementUI from 'element-ui';

@Component({
  name: 'SetRoleName',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogSetRoleNameVisible!: Boolean;

  // 有roleId的为编辑角色 否则为创建角色
  @Prop({
    type: String,
    default: ''
  })
  roleId!: String;

  created() {
    this.getRolePersonnelInfo(this.roleId);
  }

  private rules = {
    name: [
      { required: true, message: '请输入角色名称', trigger: 'blur' }
      // {
      //   pattern: /^1[1-9]\d{9}$/,
      //   message: '请填写正确的手机号',
      //   trigger: 'blur'
      // }
    ]
  };

  private checkStrictly = true;

  private formAddRole:any = {
    name: '',
    role_type: '',
    added_role_user_number: 0,
    personnel_limit: 0
  };
  private defaultProps = {
    children: 'child',
    label: 'module_name'
  };
  private dataAddRole = [];
  private dataUserAddRole = [];
  // 获取所有权限
  getRolePersonnelInfo(val: String) {
    const params = {
      company_id: UserModule.getCompanyId,
      company_role_id: val
    };
    getRolePersonnelInfo(params)
      .then(res => {
        if (res.data) {
          if (res.data.one) {
            this.formAddRole.name = res.data.one.role_name;
            this.formAddRole.role_type = res.data.one.role_type;
            this.formAddRole.added_role_user_number = res.data.one.added_role_user_number;
            this.formAddRole.personnel_limit = res.data.one.personnel_limit;
            this.dataUserAddRole = Object.values(res.data.one.module_codes);
          }
          var timestamp = new Date().getTime();
          this.dataAddRole = this.addAllMenu(this.checkParams(Object.values(res.data.all), timestamp));
          var that = this;
          // 强行延迟设置 否则getNode会为null
          setTimeout(function() {
            that.getCheckedItem(that.dataAddRole, that.dataUserAddRole);
          }, 100);
        } else {
          this.dataUserAddRole = [];
          this.dataAddRole = [];
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  private setDisabled(data:any, disabled:boolean) {
    for (var i = 0; i < data.length; i++) {
      if (data[i].child) {
        this.setDisabled(data[i].child, disabled);
      }
      data[i].disabled = true;
      let temp = data[i];
      this.$set(data, temp, i);
    }
  }
  // 最外层添加所有订单项
  addAllMenu(data:any) {
    var finalArr:any = [];
    var f = {
      id: -1,
      module_code: '',
      module_name: '所有菜单',
      child: data
    };
    finalArr.push(f);
    return finalArr;
  }
  // 滤掉不让用户看见的的权限
  checkParams(data:any, time:any) {
    var arr:any = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].child) {
        data[i].child = this.checkParams(data[i].child, time);
      }
      if ((data[i].is_free || (time < data[i].end_time)) && data[i].module_code !== 'ls100000') {
        arr.push(data[i]);
      }
    }
    return arr;
  }

  // 设置选中项
  getCheckedItem(all: any, use: any) {
    use.forEach((i: string, n: any) => {
      var node = (this.$refs.tree as ElementUI.Tree).getNode(i);
      //查看部门报修单下只有一个节点  目前组件选择上级 下级就会选中 
      if(i=="ls122000"){
        //设置父级选中 不判断是否是子节点
        if (node){
          (this.$refs.tree as any).setChecked(node, true);
        }
      }
      //只有是叶子节点才会选中  
      if (node && node.isLeaf) {
        (this.$refs.tree as any).setChecked(node, true);
      }
    });
  }
  // 关闭
  close() {
    this.$emit('close', false);
  }
  // 保存
  finishRole() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        if (this.roleId === '') {
          this.checkCreateParams();
        } else {
          this.checkEditParams();
        }
      } else {
        return false;
      }
    });
  }
  checkEditParams() {
    var checked1 = (this.$refs.tree as any).getCheckedKeys();
    var checked2 = (this.$refs.tree as any).getHalfCheckedKeys();
    var checked = checked1.concat(checked2);
    var str = '';
    for (var temp of checked) {
      str = str + temp + ',';
    }
    str = String(str).substring(0, String(str).length - 1);
    this.editRole(str);
  }
  // 编辑角色
  editRole(val: any) {
    const params = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      company_role_id: this.roleId,
      role_name: this.formAddRole.name,
      role_str: val,
      vip_level: (UserModule.company as any).vip_level
    };
    editRole(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.$emit('edit', false);
      })
      .catch(err => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }
  // 检查创建角色参数
  checkCreateParams() {
    var checked1 = (this.$refs.tree as any).getCheckedKeys();
    var checked2 = (this.$refs.tree as any).getHalfCheckedKeys();
    var checked = checked1.concat(checked2);
    var str = '';
    for (var temp of checked) {
      str = str + temp + ',';
    }
    str = String(str).substring(0, String(str).length - 1);
    this.createRole(str);
  }
  // 创建角色
  createRole(val: any) {
    const params = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      role_name: this.formAddRole.name,
      role_str: val
    };
    createRole(params)
      .then((res:any) => {
        if (res.data) {
          this.showSecussMsg(res.msg);
          this.$emit('create', false);
        }
      })
      .catch(err => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // ----------------------单选控制器-------------------
  // <el-tree @check="check" />
  private orderLock:any=['ls151010', 'ls151020']
  private deal:any=['ls153010', 'ls153020', 'ls153021', 'ls153023', 'ls153030', 'ls153050', 'ls153040', 'ls153090']
  private dealGLB:any=['ls153060']
  private taskDeal:any=['ls202010', 'ls202020', 'ls202030', 'ls202040', 'ls202050', 'ls202060', 'ls202070']
  check(data: any, check: any, childCheck:any) {
    if (check) {
      if (data.module_code === 'ls151010') {
        //查看公司订单 设置部门订单及查看新单(抢单)及抢单false
        this.setCheckedfalse(this.dealGLB);
        this.setCheckedfalse(['ls151020', 'ls151030']);
      } else if (data.module_code === 'ls151020') {
        //查看部门订单 设置公司订单及查看新单(抢单)及抢单false
        this.setCheckedfalse(this.dealGLB);
        this.setCheckedfalse(['ls151010', 'ls151030']);
      } else if (data.module_code === 'ls151030') {
        //查看新单(抢单) 设置公司订单及部门订单false  抢单true
        this.setCheckedfalse(['ls151010', 'ls151020']);
        this.setCheckedtrue(this.dealGLB);
        this.setCheckedfalse(this.deal);
      }
      if (data.module_code === 'ls153000') {
        //处理订单大级别选中 
        if (childCheck) {
          //子集选中 设置查看新单(抢单)true  处理订单大部分false
          this.setCheckedtrue(['ls151030']);
          this.setCheckedtrue(this.dealGLB);
          this.setCheckedfalse(this.deal);
        }
      } else if (data.module_code === 'ls153060') {
        //抢单 查看新单(抢单)选中 处理订单大部分false
        this.setCheckedtrue(['ls151030']);
        this.setCheckedfalse(this.deal);
      } else if (this.deal.includes(data.module_code)) {
        //有订单处理  查看新单(抢单)及抢单false
        this.setCheckedfalse(this.dealGLB);
        this.setCheckedfalse(['ls151030']);
      }
      //有任务处理 设置查看任务ture
      if (this.taskDeal.includes(data.module_code)) {
        this.setCheckedtrue(['ls201000']);
      }
      // if (data.module_code === 'ls122100') {
      //   this.setCheckedfalse(['ls121000']);
      // }
      // if (data.module_code === 'ls121000') {
      //   this.setCheckedfalse(['ls122000','ls122100']);
      // }
    }else{
      //查看部门子级报修单取消 查看部门报修单还是选中
      if (data.module_code === 'ls122100') {
        this.setCheckedtrue(['ls122000']);
      }
      //查看部门报修单取消  
    }
  }
  private getNode(moduleCode:any) {
    var node = (this.$refs.tree as ElementUI.Tree).getNode(moduleCode);
    return node;
  }
  private setCheckedKeys(val:any, check:any) {
    (this.$refs.tree as any).setCheckedKeys(val, check);
  }

  private setCheckedfalse(val: any) {
    val.forEach((code: any) => {
      var node = (this.$refs.tree as ElementUI.Tree).getNode(code);
      if(node){
        (this.$refs.tree as any).setChecked(node, false);
      }
    });
  }
  private setCheckedtrue(val: any) {
    val.forEach((code: any) => {
      var node = (this.$refs.tree as ElementUI.Tree).getNode(code);
      if(node){
        (this.$refs.tree as any).setChecked(node, true);
      }
    });
  } 
  // ----------------------单选控制器-------------------
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
